/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 09/24/2019
 *
 * @version 0.3
 * Revisions:
 * 09/24/2019 - BW - Initial Creation
 * 07/26/2021 - BW - Added: SessionTimeOut
 * 08/06/2021 - BW - Added: CaseMenuCount
 *
 * Description/Purpose:
 * Overall Main JS file
 ************************************************************** */
import '../scss/app.scss';


import Footer from 'layout/footer';
import Header from 'layout/header';
import PageHeaderAction from 'layout/page-header-action';
import StackTraceError from 'component/stack-trace-error/stack-trace-error';
import MediaWatch from 'component/media-watch/media-watch';
import JQueryFunctionUtil from "util/jquery-function";
import SessionTimeOut from "component/session-time-out/session-time-out";
import CaseMenuCount from "./component/case-menu-count/case-menu-count";

$(() => {
  JQueryFunctionUtil.init();
  MediaWatch.init();
  StackTraceError.init();
  Header.init();
  PageHeaderAction.init();
  Footer.init();
  window.CaseAnywhereSessionTimeOut = SessionTimeOut.init();
  CaseMenuCount.init();
  $(document).foundation();
});
